import edit_button from "../edit_button.html";

export default function (nga, admin) {
  var fp = admin.getEntity("fingerprint");
  fp.listView()
    .title(
      '<h4>Finger prints <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga.field("id", "string").isDetailLink(false).label("ID"),
      nga
        .field("SmartCard", "string")
        .map(function app(value) {
          const a = JSON.parse(value);
          if (typeof a == "string") {
            return a;
          } else {
            return a.join(",");
          }
        })
        .isDetailLink(false)
        .label("Customer ids"),

      nga
        .field("startTime", "string")
        .map(function app(value) {
          return value;
        })
        .isDetailLink(false)
        .label("StartTime"),

      nga.field("lock", "boolean").cssClasses("hidden-xs").label("Lock"),
      nga.field("content", "string").cssClasses("hidden-xs").label("Content"),
      nga.field("fontSize").isDetailLink(false).label("fontSize"),
      nga
        .field("fontColor", "string")
        .cssClasses("hidden-xs")
        .label("fontColor"),

      nga.field("fontAlpha").cssClasses("hidden-xs").label("fontAlpha"),
      nga
        .field("backgroundColor", "string")
        .cssClasses("hidden-xs")
        .label("backgroundColor"),
      nga
        .field("backgroundAlpha")
        .cssClasses("hidden-xs")
        .label("backgroundAlpha"),
      nga.field("showtimes").cssClasses("hidden-xs").label("showtimes"),
      nga.field("duration").cssClasses("hidden-xs").label("duration"),
      nga.field("interval").cssClasses("hidden-xs").label("interval"),
      nga
        .field("targetType", "string")
        .cssClasses("hidden-xs")
        .label("targetType"),
      nga.field("positionType").cssClasses("hidden-xs").label("positionType"),
      nga.field("posx").cssClasses("hidden-xs").label("posx"),
      nga.field("posy").cssClasses("hidden-xs").label("posy"),
      nga.field("showFrequency").cssClasses("hidden-xs").label("showFrequency"),
      nga.field("displayType").cssClasses("hidden-xs").label("displayType"),
      nga.field("contentType").cssClasses("hidden-xs").label("contentType"),
      nga.field("channels", "string").cssClasses("hidden-xs").label("channels"),
      nga
        .field("endTime", "string")
        .map(function app(value) {
          // let d = new Date(parseInt(value));

          // return (
          //   d.getFullYear() +
          //   "-" +
          //   d.getMonth() +
          //   "-" +
          //   d.getDate() +
          //   "  " +
          //   d.getHours() +
          //   ":" +
          //   d.getMinutes() +
          //   ":" +
          //   d.getSeconds()
          // );
          return value;
        })
        .cssClasses("hidden-xs")
        .label("EndTime"),

      // nga.field("createdAt", "datetime").editable(false).label("First Login"),
      // nga.field("updatedAt", "datetime").editable(false).label("Last Login"),
    ])
    .filters([
      nga.field('q')
      .label('')
      .template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
      .pinned(true),
    ])
    .listActions([])
    .exportFields([fp.listView().fields()]);

  // combo
  //   .creationView()
  //   .onSubmitSuccess([
  //     "progression",
  //     "notification",
  //     "$state",
  //     "entry",
  //     "entity",
  //     function (progression, notification, $state, entry, entity) {
  //       progression.done();
  //       $state.go($state.get("edit"), {
  //         entity: entity.name(),
  //         id: entry._identifierValue,
  //       });
  //       return false;
  //     },
  //   ])
  //   .title(
  //     '<h4>Products & Services <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Product</h4>'
  //   )
  //   .fields([
  //     nga
  //       .field("product_id", "string")
  //       .attributes({ placeholder: "Product ID" })
  //       .validation({ required: true })
  //       .label("Product ID"),
  //     nga
  //       .field("name", "string")
  //       .attributes({ placeholder: " Name of your product" })
  //       .validation({ required: true })
  //       .label("Name"),
  //     nga
  //       .field("duration")
  //       .attributes({ placeholder: "Duration of this product in days" })
  //       .validation({ required: true })
  //       .label("Duration"),
  //     nga
  //       .field("value", "number")
  //       .attributes({ placeholder: "Price of the product" })
  //       .validation({ required: true })
  //       .label("Value"),
  //     nga
  //       .field("isavailable", "boolean")
  //       .attributes({ placeholder: "Is Available" })
  //       .validation({ required: true })
  //       .label("Is Available"),
  //     nga.field("template").label("").template(edit_button),
  //   ]);

  //   combo
  //     .editionView()
  //     .actions(["list"])
  //     .title(
  //       '<h4>Products & Services <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.name }}</h4>'
  //     )
  //     .fields([
  //       combo.creationView().fields(),
  //       nga
  //         .field("", "referenced_list")
  //         .label("Packages")
  //         .targetEntity(admin.getEntity("comboPackages"))
  //         .targetReferenceField("combo_id")
  //         .targetFields([
  //           nga
  //             .field("package_id", "reference")
  //             .targetEntity(admin.getEntity("Packages"))
  //             .targetField(nga.field("package_name"))
  //             .label("Package"),
  //           nga
  //             .field("package_id", "reference")
  //             .targetEntity(admin.getEntity("Packages"))
  //             .targetField(
  //               nga.field("package_type").map(function getpckdes(value, entry) {
  //                 return entry["package_type.description"];
  //               })
  //             )
  //             .label("Package Type"),
  //         ])
  //         .listActions([
  //           '<ma-delete-button label="Remove" entry="entry" entity="entity" size="xs"></ma-delete-button>',
  //         ]),
  //       nga
  //         .field("ADD PACKAGE", "template")
  //         .label("")
  //         .template(
  //           '<ma-create-button entity-name="comboPackages" class="pull-right" label="ADD PACKAGE" default-values="{ combo_id: entry.values.id }"></ma-create-button>'
  //         ),
  //     ]);

  return fp;
}



// WEBPACK FOOTER //
// ./js/fingerprint/config.js